'use strict';

export default function routes($stateProvider) 
{
	'ngInject';

	//console.log("Importing event:routes");
	
	$stateProvider
		.state('event', {
			url: '/ev/{id:int}',
			template: require('./event.html'),
			controller: 'EventController',
			controllerAs: 'vm'
		});
}



// WEBPACK FOOTER //
// ./client/app/frontend/event/event.routes.js